document.addEventListener("DOMContentLoaded", function () {
  const resetBtns = document.querySelectorAll(".resetFiltersBtn");
  // const mobViewResultBtn = document.querySelector(
  //   "#mob-close-facet-result-count-btn",
  // );
  let lastHash = "";

  function toggleResetButtons() {
    const hash = window.location.hash.replace("#", "");
    const params = new URLSearchParams(hash);

    let filtersApplied = false;

    for (const key of params.keys()) {
      if (key.startsWith("f-")) {
        filtersApplied = true;
        break;
      }
    }

    resetBtns.forEach((btn) => {
      btn.style.display = filtersApplied ? "block" : "none";
    });
    // mobViewResultBtn.style.display = filtersApplied ? "block" : "none";
  }

  // initial check
  toggleResetButtons();
  lastHash = window.location.hash;

  // detect Shopify AJAX filter URL updates
  setInterval(() => {
    if (window.location.hash !== lastHash) {
      lastHash = window.location.hash;
      toggleResetButtons();
    }
  }, 300);

  // reset filters click
  resetBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const baseUrl =
        window.location.origin +
        window.location.pathname +
        "#sortCriteria=relevance";

      window.location.href = baseUrl;
    });
  });
});
